
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consultations",
      function () {
        return require("private-next-pages/consultations/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/consultations"])
      });
    }
  